'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SpinButton = function SpinButton(_ref) {
    var whenClicked = _ref.whenClicked,
        classNames = _ref.classNames,
        inputType = _ref.inputType,
        showSpinner = _ref.showSpinner,
        spinText = _ref.spinText,
        showIcon = _ref.showIcon,
        iconClass = _ref.iconClass,
        buttonText = _ref.buttonText,
        tabIndex = _ref.tabIndex,
        rest = _objectWithoutProperties(_ref, ['whenClicked', 'classNames', 'inputType', 'showSpinner', 'spinText', 'showIcon', 'iconClass', 'buttonText', 'tabIndex']);

    return _react2.default.createElement(
        'button',
        _extends({
            onClick: whenClicked,
            className: '' + classNames,
            type: inputType ? inputType : "button",
            disabled: showSpinner,
            tabIndex: '' + tabIndex
        }, rest),
        showSpinner ? _react2.default.createElement('div', { className: 'mr-1 spinner-grow spinner-grow-sm' }) : showIcon ? _react2.default.createElement('i', { className: '' + iconClass }) : null,
        showSpinner ? ' ' + spinText : buttonText
    );
};

SpinButton.propTypes = {
    whenClicked: _propTypes2.default.func,
    classNames: _propTypes2.default.string.isRequired,
    showSpinner: _propTypes2.default.bool.isRequired,
    spinText: _propTypes2.default.string.isRequired,
    buttonText: _propTypes2.default.string.isRequired
};

exports.default = SpinButton;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/SpinButton.jsx
// module id = 353
// module chunks = 0